import { create } from "zustand";

type GlobalStoreData = {
  showLoading?: boolean;
  setShowLoading: (message: boolean) => void;
  setGlobalStore: (data: Partial<GlobalStoreData>) => void;
};

export const useGlobalStore = create<GlobalStoreData>()(set => {
  return {
    showLoading: false,
    setShowLoading: loading => set({ showLoading: loading }),
    setGlobalStore: data => set(data)
  };
});

export default useGlobalStore;
